/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      lib util — string/object utilities (attribute trimming, HTML escaping,
 *              string-boolean coercion)
 *   extends:   -
 *   template:  none
 *   args:      -
 *   uses:      -
 *   siblings:  sibling utility/custom-fields.js, utility/models.js, utility/ajax.js
 *              (re-exported together via the ../utility.js barrel)
 *   tests:     tests/unit/lib/escape-html-test.js, tests/unit/lib/utility-test.js,
 *              tests/unit/lib/utility-wave5-test.js
 *   gotchas:   escapeHtml is a LOCAL copy — beebee-base cannot depend on beebee-helper
 *              (would create a dependency cycle) — so it must be kept manually in sync if
 *              the canonical beebee-helper version changes.
 *
 * @module beebee-base/lib/utility/strings
 * @description String & data manipulation utilities.
 */

/**
 * Pulisce un attributo stringa rimuovendo spazi bianchi
 * @param {*} item - Valore da pulire
 * @returns {*} Valore pulito o null
 */
function clearAttribute(item) {
  if (typeof item === 'string') {
    const trimmed = item.trim();
    return trimmed || null;
  }
  return item;
}
const HTML_ESCAPE_MAP = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};

/**
 * Escape plain text for safe interpolation into HTML strings.
 * Replaces & < > " ' with their entity equivalents. Returns a plain string.
 * Local copy (beebee-base cannot depend on beebee-helper: dependency cycle).
 * @param {*} str - Value to escape
 * @returns {string} Escaped string ('' for null/undefined)
 */
function escapeHtml(str) {
  if (str === null || str === undefined) {
    return '';
  }
  return String(str).replace(/[&<>"']/g, ch => HTML_ESCAPE_MAP[ch]);
}

/**
 * Converte ricorsivamente stringhe 'true'/'false' in booleani
 * @param {Object} obj - Oggetto da convertire
 * @returns {Object} Oggetto con booleani convertiti
 */
function convertObjStringToBoolean(obj) {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  // A Date (or any class instance with no own enumerable props) would recurse
  // into an empty {} and be silently discarded — preserve it as-is.
  if (obj instanceof Date) {
    return obj;
  }
  const newObj = Array.isArray(obj) ? [] : {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key];
      if (typeof value === 'object' && value !== null) {
        newObj[key] = convertObjStringToBoolean(value);
      } else {
        newObj[key] = value === 'true' ? true : value === 'false' ? false : value;
      }
    }
  }
  return newObj;
}

export { clearAttribute, convertObjStringToBoolean, escapeHtml };
//# sourceMappingURL=strings.js.map
